import { useCallback } from 'react'

import { useLocation, useNavigate, useSearchParams } from 'react-router'

import {
  type BidCsvImportNotice,
  resolveBidCsvImportDestination,
  toBidCsvImportReturnState,
} from '~/models/bidCsvImportReturn'
import { CSV_IMPORT_RETURN_TO_PARAM } from '~/models/csvImportReturn'

/**
 * 入札 CSV の取込画面が使う。 確定が成功したら、 トーストを出さずにすぐ入札画面へ移り、
 * 完了の案内 (件数) を location state で渡す (AC-SPOT-024 / AC-BCI-038)。
 *
 * 行き先は取込画面の URL の returnTo (検証済み) がその種別の入札画面を指す時はそれ
 * (`?workflowId=` 等を保つため)、 それ以外は入札画面の path。
 */
export function useBidCsvImportReturn(
  bidPagePath: string,
): (notice: BidCsvImportNotice) => void {
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const rawReturnTo = searchParams.get(CSV_IMPORT_RETURN_TO_PARAM)

  return useCallback(
    (notice) => {
      const destination = resolveBidCsvImportDestination(
        rawReturnTo,
        pathname,
        bidPagePath,
      )
      void navigate(destination, { state: toBidCsvImportReturnState(notice) })
    },
    [bidPagePath, navigate, pathname, rawReturnTo],
  )
}
